export const API_URL =  "https://xn----7sbhcmaqccmmwdch7bgljlbm.xn--p1ai/api"
export const SERVER_URL = "https://xn----7sbhcmaqccmmwdch7bgljlbm.xn--p1ai/"